import * as React from "react";
const CalendarIcon0Events = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={65}
        height={64}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <circle cx={32.5} cy={32} r={32} fill="#D9CDFC" />
            <rect
                width={27}
                height={31}
                x={19.564}
                y={18.759}
                fill="#fff"
                stroke="#000"
                rx={3.5}
            />
            <rect
                width={29}
                height={31}
                x={18.547}
                y={17.202}
                fill="#fff"
                stroke="#000"
                rx={3.5}
            />
            <rect
                width={31}
                height={31}
                x={17.547}
                y={15.806}
                fill="#fff"
                stroke="#000"
                rx={3.5}
            />
            <path
                fill="#000"
                stroke="#000"
                d="M17.547 19.306a3.5 3.5 0 0 1 3.5-3.5h23a3.5 3.5 0 0 1 3.5 3.5v2.5h-30v-2.5Z"
            />
            <path
                fill="#0EAA15"
                d="M32.99 27.64c1.36 0 2.447.512 3.28 1.52.815 1.024 1.231 2.448 1.231 4.256 0 1.808-.416 3.216-1.232 4.224-.832 1.008-1.92 1.52-3.28 1.52-1.344 0-2.432-.512-3.248-1.52-.832-1.008-1.248-2.416-1.248-4.224 0-1.808.416-3.232 1.248-4.256.816-1.008 1.904-1.52 3.248-1.52Zm0 10.032c1.983 0 2.783-1.232 2.783-4.256 0-3.072-.8-4.288-2.784-4.288-1.968 0-2.752 1.216-2.752 4.288 0 3.024.784 4.256 2.752 4.256Z"
            />
            <rect
                width={3}
                height={5}
                x={21.547}
                y={13.806}
                fill="#fff"
                stroke="#000"
                rx={1.5}
            />
            <rect
                width={3}
                height={5}
                x={41.547}
                y={13.806}
                fill="#fff"
                stroke="#000"
                rx={1.5}
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M.5 0h64v64H.5z" />
            </clipPath>
        </defs>
    </svg>
);
export default CalendarIcon0Events;
